import React from 'react'
import Shield from 'mdi-material-ui/Shield'

export default function MyData(props) {
  return <Shield {...props} />
}
